import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import FolderIcon from "@mui/icons-material/Folder";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import Accordion from "@mui/material/Accordion";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import Typography from "@mui/material/Typography";
import { useEffect, useState } from "react";
import { KNOWLEDGE_BASE_DATA } from "./knowledgeBaseData";

const KnowledgeBaseSidebar = ({ activeArticleId, onSelectArticle }) => {
  // Store expanded module accordion states
  const [expandedModules, setExpandedModules] = useState({
    dashboard: true,
  });

  // Automatically expand the module accordion that contains the active article
  useEffect(() => {
    KNOWLEDGE_BASE_DATA.forEach((moduleItem) => {
      moduleItem.topics.forEach((topic) => {
        topic.groups.forEach((group) => {
          group.items.forEach((item) => {
            if (item.id === activeArticleId) {
              setExpandedModules((prev) => ({ ...prev, [moduleItem.id]: true }));
            }
          });
        });
      });
    });
  }, [activeArticleId]);

  const toggleModule = (moduleId) => {
    setExpandedModules((prev) => ({
      ...prev,
      [moduleId]: !prev[moduleId],
    }));
  };

  return (
    <div className="kb-sidebar">
      <div className="kb-sidebar-title">
        <MenuBookIcon sx={{ color: "#0054A6" }} />
        <span>Modules & Topics</span>
      </div>

      {KNOWLEDGE_BASE_DATA.map((moduleItem) => (
        <div key={moduleItem.id} style={{ marginTop: "12px" }}>
          {/* Main Module Accordion (e.g. Patient Workbook, Inventory) */}
          <Accordion
            expanded={Boolean(expandedModules[moduleItem.id])}
            onChange={() => toggleModule(moduleItem.id)}
            elevation={0}
            sx={{
              "&:before": { display: "none" },
              backgroundColor: "#F8FAFC",
              border: "1px solid #E2E8F0",
              borderRadius: "8px !important",
              marginBottom: "8px",
              overflow: "hidden",
            }}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon sx={{ color: "#0054A6" }} />}
              sx={{
                px: 1.5,
                py: 0.5,
                minHeight: "44px",
                backgroundColor: "#F1F5F9",
                "&:hover": { backgroundColor: "#E2E8F0" },
              }}
            >
              <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                <FolderIcon sx={{ color: "#0054A6", fontSize: "20px" }} />
                <Typography
                  sx={{
                    fontWeight: 700,
                    fontSize: "15px",
                    color: "#0F172A",
                  }}
                >
                  {moduleItem.title}
                </Typography>
              </div>
            </AccordionSummary>

            <AccordionDetails sx={{ p: 1.5, pt: 1, backgroundColor: "#FFFFFF" }}>
              {/* Sub-Topics under the Main Module (e.g. Dashboard, Stock, Service) */}
              {moduleItem.topics.map((topic) => (
                <div key={topic.id} style={{ marginBottom: "16px" }}>
                  <div className="kb-sidebar-group-title">
                    {topic.title}
                  </div>

                  {topic.groups.map((group) => (
                    <div key={group.id}>
                      {group.items.map((item) => {
                        const isActive = activeArticleId === item.id;
                        return (
                          <div
                            key={item.id}
                            className={`kb-sidebar-item ${
                              isActive ? "active" : ""
                            }`}
                            onClick={() => onSelectArticle(item.id)}
                          >
                            <span>{item.title}</span>
                            <ChevronRightIcon
                              sx={{
                                fontSize: "16px",
                                color: isActive ? "#0054A6" : "#94A3B8",
                              }}
                            />
                          </div>
                        );
                      })}
                    </div>
                  ))}
                </div>
              ))}
            </AccordionDetails>
          </Accordion>
        </div>
      ))}
    </div>
  );
};

export default KnowledgeBaseSidebar;
